import React, { useContext } from "react";
import {
  ComposedChart,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Bar,
  Cell,
} from "recharts";
import Paper from "@mui/material/Paper";
import { Typography } from "@mui/material";
import { dashboardContext } from "../../Dashboard";

const fillColor = [
  "#111111",
  "#222222",
  "#888888",
  "#999999",
  "#222222",
  "#888888",
  "#999999",
];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const val = payload[0]?.value;
    return (
      <Paper className="custom-tooltip" sx={{ px: "10px", py: "10px" }}>
        <Typography className="label" sx={{ display: "inline" }}>
          {`${label}: `}
        </Typography>
        <Typography
          className="label"
          sx={{ fontWeight: "bold", display: "inline" }}
        >
          {typeof val === "number" ? val.toLocaleString() : val}
        </Typography>
      </Paper>
    );
  }
  return null;
};

export default function ActivePersonnels() {
  const { activeTransitionList = [] } = useContext(dashboardContext);
  const day = new Date().getDay();

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "480px",
      }}
      elevation={0}
    >
      <Typography sx={{ fontSize: "16px", fontWeight: "bold" }}>
        新着情報の推移(直近5週間)
      </Typography>
      <ComposedChart
        height={300}
        width={480}
        layout="vertical"
        data={activeTransitionList}
      >
        <XAxis
          type="number"
          tickFormatter={(num) => (typeof num === "number" ? num.toLocaleString() : num)}
        />
        <YAxis type="category" dataKey="name" />
        <Tooltip content={<CustomTooltip />} />
        <CartesianGrid stroke="#f5f5f5" />
        <Bar dataKey="人" barSize={4} fillOpacity={1}>
          {activeTransitionList.map((entry, index) => (
            <Cell
              key={`cell-${entry.name || index}`}
              fill={index === 5 ? fillColor[day] : "#28345e"}
              stroke={index === 5 ? fillColor[day] : "#28345e"}
            />
          ))}
        </Bar>
      </ComposedChart>
    </Paper>
  );
}